import { readApiEndpointV1 } from "../utils/config";
import backendClient from "./backendClient";

export const getParticipants = (accountId, meetingId) => backendClient.get(`${readApiEndpointV1}accounts/${accountId}/meetings/${meetingId}/participants`);

export const getMeetingForm = (meetingId) =>
    backendClient.get(`${readApiEndpointV1}public/meetings/${meetingId}`);
